import { zimbaApi, contentApi } from '@/infrastructure/Configuration'

export default class CorporateService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async getPressReleases (params) {
    const url = `${zimbaApi}/press?limit=${params.limit}&offset=${params.offset}&topic=${params.topic}&area=${params.area}&year=${params.year}`
    const response = await this.httpClient.get(url)

    return response.data
  }

  async getTopics () {
    const url = `${contentApi}/corporate/topics`
    const response = await this.httpClient.get(url)

    return response.data
  }

  async getAreas () {
    const url = `${contentApi}/corporate/areas`
    const response = await this.httpClient.get(url)

    return response.data
  }
}
